import cx from 'clsx';
import React from 'react';
import { forwardRef } from 'react';
import styles from './BlockContent.module.scss';

interface OwnProps {
  direction?: 'column' | 'row';
  noPadding?: boolean;
}

type BlockContentProps = JSX.IntrinsicElements['div'] & OwnProps;

const BlockContent = forwardRef<HTMLDivElement, BlockContentProps>((props, ref) => {
  const { className, direction = 'column', noPadding = false, ...rest } = props;

  const blockClassName = cx({
    [styles.content]: true,
    [styles[direction]]: true,
    [styles.noPadding]: noPadding,
    ...(className && { [className]: true }),
  });

  return <div className={blockClassName} {...rest} ref={ref} />;
});

export default BlockContent;
